import React from 'react';

import { Text } from '../../../../../../shared/components/Text';
import { PayoutsListRowProps } from '../../../types/PayoutsListRowProps';

export const referenceNumberFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'reference',
    headerName: <Text tId={'REFERENCE'} />,
    renderCell: (rowData: PayoutsListRowProps) => (
      <div className="shorted-cell simple-select overflow-text-ellipsis">
        <div style={{ minWidth: '120px' }}>{rowData.row.reference}</div>
      </div>
    ),
  };
};
